<script>
import inputMixin from '@/vuetify-mixins/input-mixin'

export default {
	lang: 'shop',
	mixins: [inputMixin],
	props: {
		countryId: Number,
		label: String,
		shippingContext: Boolean,
		availableCountries: Array,
	},
	model: {
		prop: 'countryId',
		event: 'updateModel',
	},
	data() {
		return {
			countries: [],
			loading: false,
		}
	},
	computed: {
		selectedCountry() {
			return this.countries.find((country) => country.id == this.countryId)
		},
	},
	watch: {
		selectedCountry(value) {
			this.$emit('country-selected', value)
		},
	},
	methods: {
		async loadData() {
			this.loading = true
			let countries
			if (this.availableCountries?.length) {
				countries = this.availableCountries
			} else {
				await this.$shopApi.get({
					url: '/location/countries',
					query: { shippingContext: Number(this.shippingContext) },
					loading: false,
					onSuccess: ({ data }) => {
						countries = data.countries
					},
					cache: true,
				})
			}
			this.countries = countries?.sort((a, b) => (a.name > b.name ? 1 : -1)) || []
			if (this.countries.length == 1) {
				this.$nextTick(() => {
					this.onInput(this.countries[0].id)
				})
			}
			this.loading = false
		},
		onInput($event) {
			this.$emit('updateModel', $event)
		},
		focus() {
			this.$refs.selector.focus()
		},
	},
	mounted() {
		this.loadData()
	},
}
</script>

<template>
	<Autocomplete
		ref="selector"
		:label="label || $lang('País')"
		:placeholder="$lang('Buscar...')"
		@input="onInput"
		:items="countries"
		:multiple="false"
		item-text="name"
		item-value="id"
		:loading="loading"
		:no-data-text="$lang('No se han encontrado resultados...')"
		:hide-no-data="loading"
		:value="countryId"
		:error-messages="validationErrors"
		v-bind="$attrs"
		prepend-icon="mdi-earth"
	/>
</template>

